import * as React from "react";

function SvgClearbit(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 72 72"
      {...{ ...props, ref }}
    >
      <defs>
        <linearGradient
          id="Clearbit_svg__a"
          x1="50%"
          x2="100%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#DEF2FE" />
          <stop offset="100%" stopColor="#DBF1FE" />
        </linearGradient>
        <linearGradient id="Clearbit_svg__b" x1="0%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#57BCFD" />
          <stop offset="100%" stopColor="#51B5FD" />
        </linearGradient>
        <linearGradient
          id="Clearbit_svg__c"
          x1="37.5%"
          x2="62.5%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#1CA7FD" />
          <stop offset="100%" stopColor="#148CFC" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="url(#Clearbit_svg__a)"
          d="M72 36v16.77l-.004.868c-.06 6.035-.75 8.353-2 10.688a13.63 13.63 0 01-5.67 5.67l-.326.171C61.658 71.364 59.16 72 52.77 72H36V36h36z"
        />
        <path
          fill="url(#Clearbit_svg__b)"
          d="M64.326 2.003a13.63 13.63 0 015.67 5.67l.171.327C71.364 10.342 72 12.84 72 19.23V36H36V0h16.77c6.687 0 9.112.696 11.556 2.003z"
        />
        <path
          fill="url(#Clearbit_svg__c)"
          d="M36 0v72H19.23l-.868-.004c-6.035-.06-8.353-.75-10.688-2a13.63 13.63 0 01-5.67-5.67L1.832 64C.636 61.658 0 59.16 0 52.77V19.23c0-6.687.696-9.112 2.003-11.556a13.63 13.63 0 015.67-5.67L8 1.832C10.342.636 12.84 0 19.23 0H36z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgClearbit);
